// client/src/components/Admin/PlanesEducaCmp/_shared/PlanFeatureList.js
//
// M07 - Lista de servicios incluidos del plan. Recibe el plan y
// pinta los 5 booleanos como check/cross.

import React from "react";
import { CheckCircleFilled, MinusCircleFilled } from "@ant-design/icons";
import styles from "./PlanFeatureList.module.scss";

const FEATURES = [
  { key: "educamaker", label: "Educamaker" },
  { key: "curseBasic", label: "Form. iniciacion" },
  { key: "curseCertification", label: "Form. certificacion" },
  { key: "support", label: "Soporte" },
  { key: "publicity", label: "Publicidad" },
];

export function PlanFeatureList({ plan, showTitle = true }) {
  return (
    <div>
      {showTitle ? <div className={styles.sectionTitle}>Incluye</div> : null}
      <div className={styles.featureList}>
        {FEATURES.map((f) => {
          const yes = !!plan?.[f.key];
          return (
            <div key={f.key} className={styles.feature}>
              {yes ? (
                <CheckCircleFilled className={styles.iconYes} />
              ) : (
                <MinusCircleFilled className={styles.iconNo} />
              )}
              <span
                className={`${styles.label} ${yes ? "" : styles.labelOff}`}
                title={f.label}
              >
                {f.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
